import * as types from 'src/state/ducks/notificationTemplate/types';
import { NotificationTemplateEntity } from 'src/firebase/db/NotificationTemplates';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetNotificationTemplate
  | SuccessGetNotificationTemplate
  | FailGetNotificationTemplate
  | GetNotificationTemplates
  | SuccessGetNotificationTemplates
  | FailGetNotificationTemplates
  | InitNotificationTemplate
  | EditNotificationTemplate
  | ValidateNotificationTemplate
  | SuccessValidateNotificationTemplate
  | FailValidateNotificationTemplate
  | CreateNotificationTemplate
  | SuccessCreateNotificationTemplate
  | FailCreateNotificationTemplate
  | UpdateNotificationTemplate
  | SuccessUpdateNotificationTemplate
  | FailUpdateNotificationTemplate
  | DeleteNotificationTemplate
  | SuccessDeleteNotificationTemplate
  | FailDeleteNotificationTemplate;

/**
 * Get
 */
interface GetNotificationTemplate {
  type: typeof types.GET_NOTIFICATION_TEMPLATE;
  payload: string;
}
export const getNotificationTemplate = (payload: GetNotificationTemplate['payload']) => ({
  type: types.GET_NOTIFICATION_TEMPLATE,
  payload,
});

interface SuccessGetNotificationTemplate {
  type: typeof types.SUCCESS_GET_NOTIFICATION_TEMPLATE;
  payload: APISuccessfulResponse<NotificationTemplateEntity>;
}
export const successGetNotificationTemplate = (
  payload: SuccessGetNotificationTemplate['payload'],
) => ({
  type: types.SUCCESS_GET_NOTIFICATION_TEMPLATE,
  payload,
});

interface FailGetNotificationTemplate {
  type: typeof types.FAIL_GET_NOTIFICATION_TEMPLATE;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetNotificationTemplate = (payload: FailGetNotificationTemplate['payload']) => ({
  type: types.FAIL_GET_NOTIFICATION_TEMPLATE,
  payload,
});

/**
 * Get (multiple)
 */
interface GetNotificationTemplates {
  type: typeof types.GET_NOTIFICATION_TEMPLATES;
  payload: {
    shopId: string;
    templateIds?: string[] | undefined;
  };
}
export const getNotificationTemplates = (payload: GetNotificationTemplates['payload']) => ({
  type: types.GET_NOTIFICATION_TEMPLATES,
  payload,
});

interface SuccessGetNotificationTemplates {
  type: typeof types.SUCCESS_GET_NOTIFICATION_TEMPLATES;
  payload: APISuccessfulResponse<NotificationTemplateEntity[]>;
}
export const successGetNotificationTemplates = (
  payload: SuccessGetNotificationTemplates['payload'],
) => ({
  type: types.SUCCESS_GET_NOTIFICATION_TEMPLATES,
  payload,
});

interface FailGetNotificationTemplates {
  type: typeof types.FAIL_GET_NOTIFICATION_TEMPLATES;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetNotificationTemplates = (payload: FailGetNotificationTemplates['payload']) => ({
  type: types.FAIL_GET_NOTIFICATION_TEMPLATES,
  payload,
});

/**
 * Init
 */
interface InitNotificationTemplate {
  type: typeof types.INIT_NOTIFICATION_TEMPLATE;
}
export const initNotificationTemplate = () => ({
  type: types.INIT_NOTIFICATION_TEMPLATE,
});

/**
 * ReEdit
 */
interface EditNotificationTemplate {
  type: typeof types.EDIT_NOTIFICATION_TEMPLATE;
  payload: NotificationTemplateEntity;
}
export const editNotificationTemplate = (payload: EditNotificationTemplate['payload']) => ({
  type: types.EDIT_NOTIFICATION_TEMPLATE,
  payload,
});

/**
 * Validate
 */
interface ValidateNotificationTemplate {
  type: typeof types.VALIDATE_NOTIFICATION_TEMPLATE;
  payload: NotificationTemplateEntity;
}
export const validateNotificationTemplate = (payload: ValidateNotificationTemplate['payload']) => ({
  type: types.VALIDATE_NOTIFICATION_TEMPLATE,
  payload,
});

interface SuccessValidateNotificationTemplate {
  type: typeof types.SUCCESS_VALIDATE_NOTIFICATION_TEMPLATE;
  payload: APISuccessfulResponse<NotificationTemplateEntity>;
}
export const successValidateNotificationTemplate = (
  payload: SuccessValidateNotificationTemplate['payload'],
) => ({
  type: types.SUCCESS_VALIDATE_NOTIFICATION_TEMPLATE,
  payload,
});

interface FailValidateNotificationTemplate {
  type: typeof types.FAIL_VALIDATE_NOTIFICATION_TEMPLATE;
  payload: ValidationResponse | APIFailedResponse;
}
export const failValidateNotificationTemplate = (
  payload: FailValidateNotificationTemplate['payload'],
) => ({
  type: types.FAIL_VALIDATE_NOTIFICATION_TEMPLATE,
  payload,
});

/**
 * Create
 */
interface CreateNotificationTemplate {
  type: typeof types.CREATE_NOTIFICATION_TEMPLATE;
  payload: NotificationTemplateEntity;
}
export const createNotificationTemplate = (payload: CreateNotificationTemplate['payload']) => ({
  type: types.CREATE_NOTIFICATION_TEMPLATE,
  payload,
});

interface SuccessCreateNotificationTemplate {
  type: typeof types.SUCCESS_CREATE_NOTIFICATION_TEMPLATE;
  payload: APISuccessfulResponse<NotificationTemplateEntity>;
}
export const successCreateNotificationTemplate = (
  payload: SuccessCreateNotificationTemplate['payload'],
) => ({
  type: types.SUCCESS_CREATE_NOTIFICATION_TEMPLATE,
  payload,
});

interface FailCreateNotificationTemplate {
  type: typeof types.FAIL_CREATE_NOTIFICATION_TEMPLATE;
  payload: ValidationResponse | APIFailedResponse;
}
export const failCreateNotificationTemplate = (
  payload: FailCreateNotificationTemplate['payload'],
) => ({
  type: types.FAIL_CREATE_NOTIFICATION_TEMPLATE,
  payload,
});

/**
 * Update
 */
interface UpdateNotificationTemplate {
  type: typeof types.UPDATE_NOTIFICATION_TEMPLATE;
  payload: NotificationTemplateEntity;
}
export const updateNotificationTemplate = (payload: UpdateNotificationTemplate['payload']) => ({
  type: types.UPDATE_NOTIFICATION_TEMPLATE,
  payload,
});

interface SuccessUpdateNotificationTemplate {
  type: typeof types.SUCCESS_UPDATE_NOTIFICATION_TEMPLATE;
  payload: APISuccessfulResponse<NotificationTemplateEntity>;
}
export const successUpdateNotificationTemplate = (
  payload: SuccessUpdateNotificationTemplate['payload'],
) => ({
  type: types.SUCCESS_UPDATE_NOTIFICATION_TEMPLATE,
  payload,
});

interface FailUpdateNotificationTemplate {
  type: typeof types.FAIL_UPDATE_NOTIFICATION_TEMPLATE;
  payload: ValidationResponse | APIFailedResponse;
}
export const failUpdateNotificationTemplate = (
  payload: FailUpdateNotificationTemplate['payload'],
) => ({
  type: types.FAIL_UPDATE_NOTIFICATION_TEMPLATE,
  payload,
});

/**
 * Delete
 */
interface DeleteNotificationTemplate {
  type: typeof types.DELETE_NOTIFICATION_TEMPLATE;
  payload: string;
}
export const deleteNotificationTemplate = (payload: DeleteNotificationTemplate['payload']) => ({
  type: types.DELETE_NOTIFICATION_TEMPLATE,
  payload,
});

interface SuccessDeleteNotificationTemplate {
  type: typeof types.SUCCESS_DELETE_NOTIFICATION_TEMPLATE;
  payload: APISuccessfulResponse<NotificationTemplateEntity>;
}
export const successDeleteNotificationTemplate = (
  payload: SuccessDeleteNotificationTemplate['payload'],
) => ({
  type: types.SUCCESS_DELETE_NOTIFICATION_TEMPLATE,
  payload,
});

interface FailDeleteNotificationTemplate {
  type: typeof types.FAIL_DELETE_NOTIFICATION_TEMPLATE;
  payload: ValidationResponse | APIFailedResponse;
}
export const failDeleteNotificationTemplate = (
  payload: FailDeleteNotificationTemplate['payload'],
) => ({
  type: types.FAIL_DELETE_NOTIFICATION_TEMPLATE,
  payload,
});
